import { useSignal } from '@preact/signals'

import { ComingSoonModal } from 'components/UI'

import { TeamsSection } from './TeamsSection'
import { HubsSection } from './HubsSection'
import { PullRequestsSection } from './PullRequestsSection'

const HomeRightSidebar = () => {
	const modalContent = useSignal({
		isOpen: false,
		title: '',
		description: ''
	})

	const closeModal = () => {
		modalContent.value = {
			isOpen: false,
			title: modalContent.value.title,
			description: modalContent.value.description
		}
	}

	const openModal = (title: string, description: string) => {
		modalContent.value = {
			isOpen: true,
			title,
			description
		}
	}

	return (
		<>
			<ComingSoonModal
				description={modalContent.value.description}
				isModalOpen={modalContent.value.isOpen}
				onCloseModal={closeModal}
				title={modalContent.value.title}
			/>
			<aside class='mt-6 hidden h-full w-72 space-y-8 overflow-y-auto lg:block'>
				{/* Teams Section */}
				<TeamsSection openModal={openModal} />

				{/* Hubs Section */}
				<HubsSection openModal={openModal} />

				{/* Pull Requests Section */}
				<PullRequestsSection openModal={openModal} />
			</aside>
		</>
	)
}

export { HomeRightSidebar }
